import { useLogto } from '@logto/react';
import { useState } from 'react';

export function useLogtoStarting(): boolean {
  const { isLoading } = useLogto();
  const [hasSettled, setHasSettled] = useState(false);
  if (!isLoading && !hasSettled) setHasSettled(true);

  return isLoading && !hasSettled;
}
